import { useCartContext } from "app/providers/CartProvider";
import { useOrderContext } from "app/providers/OrderProvider";
import Skeleton from "react-loading-skeleton";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

interface CheckoutBumbalHeaderProps {
  className?: string;
}

const CheckoutBumbalHeader = ({ className }: CheckoutBumbalHeaderProps) => {
  const { order } = useOrderContext();
  const { isSampleSale } = useCartContext();

  const shippingContact =
    order?.shippingAddress.firstName || order?.shippingAddress.lastName
      ? `${order?.shippingAddress.firstName} ${order?.shippingAddress.lastName}`
      : order?.shippingAddress.company;

  // Check if the order is a zakelijk order
  if (order?.isZakelijkOrder) {
    return (
      <header className={concatClassnames("", className)}>
        <Heading headingLevel="h2" className="gg-mb-4 gg-text-2xl">
          Plan je bezorgafspraak
        </Heading>

        <div className="gg-mb-1 gg-flex">
          <Text className="gg-mr-1 gg-font-bold">Referentienummer:</Text>
          {order?.orderNumber || <Skeleton className="gg-w-40" />}
        </div>

        <div className="gg-flex">
          <Text className="gg-mr-1 gg-font-bold">Klantnaam:</Text>
          {shippingContact || <Skeleton className="gg-w-40" />}
        </div>
      </header>
    );
  }

  // Check if the order is a sample sale order
  if (isSampleSale)
    return (
      <header className={concatClassnames("", className)}>
        <Heading headingLevel="h2" className="gg-mb-1 gg-text-2xl">
          Plan je afleverafspraak
        </Heading>
        <Text className="gg-mb-7">
          Kies in de kalender jouw gewenste afleverdatum.
        </Text>

        <div className="gg-mb-1 gg-flex">
          <Text className="gg-mr-1 gg-font-bold">Referentienummer:</Text>
          {order?.orderNumber || <Skeleton className="gg-w-40" />}
        </div>

        <div className="gg-flex">
          <Text className="gg-mr-1 gg-font-bold">Klantnaam:</Text>
          {shippingContact || <Skeleton className="gg-w-40" />}
        </div>
      </header>
    );

  // Default case for regular orders
  if (!isSampleSale) {
    // Check if the order is a self-assembly order
    if (order?.isSelfAssembly)
      return (
        <header className={concatClassnames("", className)}>
          <Heading headingLevel="h2" className="gg-mb-1 gg-text-2xl">
            Plan je afleverafspraak
          </Heading>
          <Text className="gg-mb-7">
            Wanneer ben je thuis om je bestelling te ontvangen? Selecteer de
            datum hier. Twee dagen van tevoren ontvang je van ons een tijdvak
            waarin je de chauffeur kunt verwachten.
          </Text>

          <div className="gg-mb-1 gg-flex">
            <Text className="gg-mr-1 gg-font-bold">Referentienummer:</Text>
            {order?.orderNumber || <Skeleton className="gg-w-40" />}
          </div>

          <div className="gg-flex">
            <Text className="gg-mr-1 gg-font-bold">Klantnaam:</Text>
            {shippingContact || <Skeleton className="gg-w-40" />}
          </div>
        </header>
      );
    else {
      return (
        <header className={concatClassnames("", className)}>
          <Heading headingLevel="h2" className="gg-mb-4 gg-text-2xl">
            Plan je gratis inmeetafspraak
          </Heading>

          <div className="gg-mb-1 gg-flex">
            <Text className="gg-mr-1 gg-font-bold">Referentienummer:</Text>
            {order?.orderNumber || <Skeleton className="gg-w-40" />}
          </div>

          <div className="gg-flex">
            <Text className="gg-mr-1 gg-font-bold">Klantnaam:</Text>
            {shippingContact || <Skeleton className="gg-w-40" />}
          </div>
        </header>
      );
    }
  }

  return <></>;
};
export default CheckoutBumbalHeader;
